import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class PlatformPaywall extends BaseModel {
  hasAdvisorPro: boolean;

  constructor(model: Partial<PlatformPaywall> = {}) {
    super();

    this.hasAdvisorPro = model.hasAdvisorPro ?? false;
  }
}
